<template>
  <Layout>
    <PageHeader :title="title" :items="items" :backButton="true" :prevRoutePath="backUrl" :backWithData="true"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <!-- <hr> -->
              <div class="media mb-3">
                  <div class="avatar-sm mr-3">
                      <span class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22">
                          <i class="mdi mdi-account-outline mdi-24px"></i>
                      </span>
                  </div>
                  <div class="media-body">
                          <h4 class="mt-3">{{this.$t("overview.table.citizen.citizen-profile")}}</h4>
                  </div>
              </div>
              <table class="table table-bordered px-2">
                  <tbody>
                      <tr>
                      <td width="20%">
                          {{ $t("table.citizen.th.name") }}
                      </td>
                      <td>
                          {{citizen.nama}}
                      </td>
                    </tr>
                    <tr>
                      <td width="20%">
                          NIK
                      </td>
                      <td>
                          {{citizen.nik}}
                      </td>
                    </tr>
                      <tr>
                      <td width="20%">
                          NKK
                      </td>
                      <td>
                          {{citizen.nkk}}
                      </td>
                    </tr>
                      <tr>
                      <td width="20%">
                          {{ $t("table.citizen.th.birthplace") }}
                      </td>
                      <td>
                          {{citizen.tempat_lahir}}
                      </td>
                    </tr>
                      
                      <tr>
                      <td width="20%">
                          {{ $t("table.citizen.th.dob") }}
                      </td>
                      <td>
                          {{citizen.tanggal_lahir}}
                      </td>
                    </tr>
                        <tr>
                      <td width="20%">
                          {{ $t("overview.table.citizen.age") }}
                      </td>
                      <td>
                          {{countAge(citizen.tanggal_lahir)}}
                      </td>
                    </tr>
                        <tr>
                      <td width="20%">
                          {{ $t("overview.table.citizen.gender") }}
                      </td>
                      <td>
                        <span v-if="citizen.jenis_kelamin == 1">L</span>
                        <span v-else>P</span>
                      </td>
                    </tr>
                      <!-- <tr>
                      <td width="20%">
                          STATUS PERNIKAHAN
                      </td>
                      <td>
                          <span v-if="citizen.kawin == 2">BELUM KAWIN</span>
                          <span v-else>KAWIN</span>
                      </td>
                    </tr> -->
                      <tr>
                      <td width="20%">
                            {{ $t("overview.table.citizen.address") }}
                      </td>
                      <td>
                          {{citizen.alamat}}
                      </td>
                    </tr>
                      <tr>
                      <td width="20%">
                          {{ $t("overview.table.citizen.tp") }}
                      </td>
                      <td>
                          <div class="form-group row">
                            <div class="col-5">
                              <b-form-tags
                                      id="tags-with-dropdown"
                                      v-model="relation"
                                      no-outer-focus
                                  >
                                      <template
                                      v-slot="{ tags, disabled, removeTag }"
                                      >
                                      <ul
                                          v-if="tags.length > 0"
                                          class="list-inline d-inline-block mb-2"
                                      >
                                          <li
                                          v-for="(tag, index) in tags"
                                          :key="index"
                                          class="list-inline-item mb-2 align-center"
                                          float="center"
                                          >
                                          <b-form-tag
                                              @remove="removeTag(tag)"
                                              :title="tag"
                                              :disabled="disabled"
                                              variant="primary"
                                          >
                                              <div class="team justify-content-centerml-5">
                                              <a
                                                  href="javascript: void(0);"
                                                  class="team-member d-inline-block"
                                              >
                                                  <img
                                                  :src="url_image + JSON.parse(tag).image"
                                                  class="rounded-circle avatar-xs m-1"
                                                  alt
                                                  />
                                              </a>
                                              </div>
                                              {{ JSON.parse(tag).name }}
                                          </b-form-tag>
                                          </li>
                                      </ul>

                                      <b-dropdown
                                          v-if="relation.length !== 1"
                                          size="sm"
                                          variant="outline-secondary"
                                          block
                                          menu-class="w-100"
                                      >
                                          <template #button-content>
                                          {{ $t("wizard.form.button.relation_profile") }}
                                          </template>
                                          <b-dropdown-form @submit.stop.prevent="() => {}">
                                          <b-form-group
                                              
                                              label-for="tag-search-input"
                                              label-cols-md="auto"
                                              class="mb-0"
                                              label-size="sm"
                                              :description="searchDesc"
                                              :disabled="disabled"
                                          >
                                              <b-form-input
                                              v-on:keyup="
                                                  searchTarget != ''
                                                  ? (show = true)
                                                  : (show = false)
                                              "
                                              v-model="searchTarget"
                                              id="tag-search-input"
                                              type="search"
                                              size="sm"
                                              autocomplete="off"
                                              ></b-form-input>
                                          </b-form-group>
                                          </b-dropdown-form>
                                          <b-dropdown-divider>
                                          
                                          </b-dropdown-divider>

                                          <b-dropdown-item-button
                                          v-show="show"
                                          v-for="(option, index) in availableOptions"
                                          :key="index"
                                          @click="onOptionClick(option)"
                                          >
                                          {{ option.name }}
                                          </b-dropdown-item-button>
                                          <b-dropdown-text
                                          v-if="availableOptions.length === 0"
                                          >
                                          {{ $t("wizard.form.validation.not_match2") }}
                                          </b-dropdown-text>
                                      </b-dropdown>
                                      </template>
                              </b-form-tags>
                            </div>
                          </div>
                      </td>
                    </tr>
                      <tr>
                      <td width="20%">
                          
                      </td>
                      <td>
                          <div>
                              <button class="xbadge btn btn-success  mr-1 mb-1 px-2 text-white" :disabled="relation.length !== 1 " @click="AddTargetCitizen">{{ $t("overview.table.citizen.save") }}</button>  
                          </div>
                      </td>
                    </tr>
                </tbody>
              </table>
              <div class="media mb-3">
                  <div class="avatar-sm mr-3">
                    <span class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22">
                      <i class="mdi mdi-account-switch-outline mdi-24px"></i>
                    </span>
                  </div>
                  <div class="media-body">
                    <h4 class="mt-3">Related Family</h4>
                  </div>
              </div>
              <div class="table-responsive">
                <table class="table table-striped mb-0">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>NIK</th>
                      <th>NKK</th>
                      <th>Birth Place</th>
                      <th>Date of Birth</th>
                      <th>Age</th>
                      <th>Gender</th>
                      <th>Address</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="fams in related_family" :key="fams._id" v-if="fams._id !== id">
                      <th scope="row">{{fams._source.nama}}</th>
                      <td>{{fams._source.nik}}</td>
                      <td>{{fams._source.nkk}}</td>
                      <td>{{fams._source.tempat_lahir}}</td>
                      <td>{{fams._source.tanggal_lahir}}</td>
                      <td>{{countAge(fams._source.tanggal_lahir)}}</td>
                      <td>
                        <span v-if="fams._source.jenis_kelamin == 1">L</span>
                        <span v-else>P</span></td>
                      <td>{{fams._source.alamat}}</td>
                      <td>
                        <router-link :to="{ name: 'citizen-view', params: { id:fams._id }}">
                        <!-- <a :href="'/citizen/view/'+fams._id"> -->
                          <b-button class="btn-sm px-3" variant="secondary" >
                            <i class="fas fa-eye"></i>
                          </b-button>
                        <!-- </a> -->
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="media mb-3">
              <div class="avatar-sm mr-3">
                <span class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22">
                  <i class="mdi mdi-account-switch-outline mdi-24px"></i>
                </span>
              </div>
              <div class="media-body">
                <h4 class="mt-3">Related Family</h4>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- end col -->
      <!-- end col -->
    </div>
    <!-- end row -->
 
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Vue from "vue";
import appConfig from "@/app.config";
import CitizenService from "@/helpers/citizen.service";
import PreferenceService from "@/helpers/preference.service.js";
import Maps from "./maps.vue"
import VueSlideBar from "vue-slide-bar";
import { required } from "vuelidate/lib/validators";
import TargetService from "@/helpers/target-profile.service";
import moment from 'moment';
import {gmapApi} from 'vue2-google-maps'
import EventBus from "@/helpers/eventBus";

export default {
  page: {
    title: "Citizen Profile Search",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { VueSlideBar, Layout, PageHeader, Maps },
  data() {
    return {
      backUrl: "/citizen",
      url_image:process.env.VUE_APP_BASE_API_URL + "target/image-project?name=",
      search_value: 0,
      id: this.$route.params.id,
      title: this.$t("overview.table.citizen.citizen-profile-detail"),
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: this.$t("overview.table.citizen.citizen-search"),
          href: "/citizen"
        },
         {
          text: this.$t("overview.table.citizen.citizen-profile-detail"),
          active: true
        }
      ],
      citizen:"",
      age:"",
      x:{ "total": { "value": 0, "relation": "eq" }, "hits": []},
      relation:[],
      elastic:"",
      options: [],
      searchTarget:"",
      loading: false,
      openMap: false,
      geocoder : null,
      citizen_lat: 0,
      citizen_long: 0,
      related_family: [],
      props_before: [],
    };
  },
  watch: {
    $route() {
      this.id = this.$route.params.id;
      this.getPreferences();
    }
  },

 computed:{
      google: gmapApi,
        rows() {
          return this.tableData.length;
        },

        criteria() {
        return this.searchTarget.trim().toLowerCase();
        },
        
        availableOptions() {
        const criteria = this.criteria;
        let element = [];
        try {
            for (let i = 0; i < this.relation.length; i++) {
            element.push(JSON.parse(this.relation[i]).id);
            }
        } catch (e) {
            element = [];
        }
        const options = this.options.filter(
            (opt) => element.indexOf(opt.id) === -1
        );
        this.show = false;
        if (criteria) {
            this.show = true;
            return options.filter((opt) =>
            opt.name.toLowerCase().includes(criteria)
            );
        }
        return options;
        },
        searchDesc() {
        if (this.criteria && this.availableOptions.length === 0) {
            return this.$t("wizard.form.validation.not_match1");
        }
        return "";
        },
        validFormat() {
        if (this.validformat != null) {
            if (this.validformat) {
            return "is-valid";
            } else {
            return "is-invalid";
            }
        }
        },
    },
  methods: {
      getPreferences(){
        PreferenceService.getAllElastic()
        .then((response) => {
            this.elastic = response.data.data[0].ip_address;
            this.getData();
        })
        .catch((err) => {
            console.log(err);
        });
    },
    openMapsModal(id, alamat){
      this.geocoder.geocode({'address': alamat}, (results, status) => {
        this.citizen_lat = results[0].geometry.location.lat()
        this.citizen_long = results[0].geometry.location.lng()
      });
      this.$bvModal.show('modal-maps'+id)
    },
    getData(){
      let data = 
         {
            "size": 100,
            "query": {
              "match": {
                "_id": this.id
              }
            }
          }
        CitizenService.searchByNIK(this.elastic, data)
        .then(response => {
            this.citizen = response.data.hits.hits[0]._source;
            this.getRelatedFamily();
            // this.countAge();
        })
        .catch(err => {
                console.log(err);
        });
    },
    getRelatedFamily(){
      if (this.citizen.nkk == 0 || this.citizen.nkk == '' || this.citizen.nkk == null ) return 
      let data = 
         {
            "size": 100,
            "query": {
              "match": {
                "nkk": this.citizen.nkk
              }
            }
          }
        CitizenService.search(this.elastic, data)
        .then(response => {
          this.related_family = response.data.hits.hits;
        })
        .catch(err => {
                console.log(err);
        });
    },
      countAge(date){
            var date = this.formatDateAge(date);
            var mount = Math.floor(moment(new Date()).diff(moment(date,"YYYY-MM-DD"),'month',true));
            var years = Math.floor(moment(new Date()).diff(moment(date,"YYYY-MM-DD"),'years',true));
            var days = Math.floor(moment(new Date()).diff(moment(date,"YYYY-MM-DD"),'days',true));
       
            var mm = mount;
            var yr = years;
            var dd = days;

            this.month = mm;
            this.years = yr;
            this.days = dd;

            var m = mm - (yr * 12);
            var dx = dd - (yr * 365);
            var ds = dx/12;
            var d = this.toFixed(ds);

            var day = parseInt(d);
            var month = m;
            var years = years;

            return years;
            // this.age = years +' Tahun, '+ month +' Bulan, '+ day +' Hari';

        },

        listProfile(){
            TargetService.getTargetBy()
            .then((response) => {
                response.data.data.forEach((val) => {
                const opt = {
                    name: val.title,
                    id: val.id_target,
                    image: val.image_project,
                };
                this.options.push(opt);
                });
            })
            .catch((err) => {
                console.log(err);
            });
        },

        onOptionClick(option) {
        // console.log(option)
        // this.relation.id = option.id;
        // this.relation.name = option.name;
        // this.relation.image = option.image;
            this.relation.push({
            name: option.name,
            id: option.id,
            image: option.image,
        });
        this.show = false;
        this.search = "";
        },

        AddTargetCitizen(){
            let data = {
                "id_target":  JSON.parse(this.relation).id,
                "nik" : this.citizen.nik,
                "nkk" : this.citizen.nkk,
                "name" : this.citizen.nama,
                "birth_place" : this.citizen.tempat_lahir,
                "date_of_birth" : this.citizen.tanggal_lahir,
                "gender" : this.citizen.jenis_kelamin,
                "address" : this.citizen.alamat,
                "religion" :null,
                "marriage_status" : this.citizen.kawin,
                "profession" : this.citizen.pekerjaan,
                "nationality" : null,
                "photo" : null,
                "specimen_signature" : null,
            }
            // console.log(data);
            CitizenService.create(data)
            .then( response => {
                Vue.swal({
                    position: "top-end",
                    icon: "success",
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 1500
                });
                this.$router.push({ name:'project-overview', params: { id: JSON.parse(this.relation).id }})
            })
            .catch(err => {
                console.log(err);
            });
        },


      formatDateAge(value){
          return moment(value).format("YYYY-MM-DD");
      },
      formatDate(value){
        return moment(value).format("YYYY-MM-DD");
      },
      toFixed(value){
      return value.toFixed(0);
    },
    recieveProps(){
      EventBus.$once("sendProps", (val) => {
        this.props_before = val
        console.log('ev => ', val);
      });
    },
  },
  created(){
    this.recieveProps();
  },
  beforeMount(){
    this.listProfile()
  },
  mounted(){
    console.log('propo =>> ', this.props_before);
    this.getPreferences();
    this.availableOptions;
    this.$gmapApiPromiseLazy().then(() => {
      if(this.google) {
        this.geocoder = new this.google.maps.Geocoder();
      }
    });
    this.totalRows = this.items.length;
    this.search_value = 100;
  }
};
</script>